import axios from 'axios';
import { store } from '../store/configure';
import { dequeueTaskForLoader, queueTaskForLoader } from 'src/features/_shared/store/sharedSlices';

export function setupAxiosLoaderInterceptor(): void {
    axios.interceptors.request.use(
        (config) => {
            store.dispatch(queueTaskForLoader('global'));
            return config;
        },
        (error) => {
            store.dispatch(dequeueTaskForLoader('global'));
            return Promise.reject(error);
        },
    );

    axios.interceptors.response.use(
        (response) => {
            store.dispatch(dequeueTaskForLoader('global'));
            return response;
        },
        (error) => {
            store.dispatch(dequeueTaskForLoader('global'));
            return Promise.reject(error);
        },
    );
}
